import type { SxProps, Theme } from '@mui/material';

export const mergeSx = (...sxProps: (SxProps<Theme> | undefined)[]): SxProps<Theme> | undefined => {
  const mergedSx = sxProps.flatMap((sxProp) => {
    if (!sxProp) {
      return [];
    }

    return Array.isArray(sxProp) ? sxProp : [sxProp];
  });

  return mergedSx.length ? (mergedSx as SxProps<Theme>) : undefined;
};
